import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@jsverse/transloco';
import { LoadingModule } from '../loading/loading.module';
import { PopoverModule } from '../popover/popover.module';
import {
    ContentPlaceholderComponent,
    CustomContentPlaceholderDirective,
} from './content-placeholder.component';

@NgModule({
  imports: [CommonModule, LoadingModule, PopoverModule, MatIconModule, TranslocoModule],
  declarations: [ContentPlaceholderComponent, CustomContentPlaceholderDirective],
  exports: [ContentPlaceholderComponent, CustomContentPlaceholderDirective],
})
export class ContentPlaceholderModule {}
